module.exports = __webpack_public_path__ + "img/5.cb4e85b7.jpg";